import $ from "jquery";

import "smartadmin-plugins/es6/SmartNotification.es6";

export const smallBox = (data, cb) => {
  $.smallBox(data, cb);
};

export const bigBox = (data, cb) => {
  $.bigBox(data, cb);
};

export const SmartMessageBox = (data, cb) => {
  $.SmartMessageBox(data, cb);
};
